import produce from 'immer'
import { actionTypes } from '../actions/foodActions'
import { getObjectData, setObjectData } from '../utils/localStorageHelper'
import { StorageKeys } from '../constants'
import { REFRESH_DATA } from '../actions/actionTypes'
// const initialState = getObjectData(StorageKeys.foodGroup) || []
const initialState = []

const FoodGroupReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.SET_FOOD_GROUP: {
                // setObjectData(StorageKeys.foodGroup, action.payload)
                return action.payload
            }
            case REFRESH_DATA: {
                // setObjectData(StorageKeys.foodGroup, [])
                return []
            }
            default:
                return state
        }
    })

export default FoodGroupReducer
